( function ( $ ) {
	'use strict';

	const ultimateGuide = $( '.layout--ultimate-guide' );


	if ( ultimateGuide.length ) {

		/*on load*/
		stickySingleNav();

		$( window ).on( 'scroll', debounce( function () {
			stickySingleNav();
		} ) );
	}

	/**
	 * Creates a debounced function that delays the invocation of the provided function until after the specified delay.
	 *
	 * @param {Function} func - The function to debounce.
	 * @param {number} delay - The number of milliseconds to delay.
	 * @returns {Function} A new debounced function.
	 */
	function debounce( func, delay ) {
		let timeoutId;
		return function ( ...args ) {
			clearTimeout( timeoutId );
			timeoutId = setTimeout( () => func.apply( this, args ), delay );
		};
	}

	/**
	 * Adds or removes the 'sticky' class to the navigation element based on the scroll position.
	 * The function locks the offset value when it first runs and uses it to determine when to add the 'sticky' class.
	 */
	function stickySingleNav() {
		var stickyElement = $( '#singleNav' );

		// Lock the offset value when the script first runs
		var stickyOffset = stickyElement.data( 'offset' ) || stickyElement.offset().top ;
		stickyElement.data( 'offset', stickyOffset );

		var scrollTop = $( window ).scrollTop();

		/**
		 * Adds the 'sticky' class if the scroll position is greater than the offset value.
		 * Removes the 'sticky' class if the scroll position is less than or equal to the offset value.
		 */
		if ( scrollTop > stickyOffset ) {
			stickyElement.addClass( 'sticky' );
		} else {
			stickyElement.removeClass( 'sticky' );
		}
	}

	var topMenu = $( '.single-navigation' ),
		menuItems = topMenu.find( 'a' ),
		scrollItems = menuItems.map( function() {
			var item = $( $( this ).attr( 'href' ) );
			if ( item.length ) {
				return item;
			}
		} );

	$( window ).scroll( function() {
		var viewportBottom = $( this ).scrollTop() + $( window ).innerHeight();

		// Find the first section whose top is above the viewport's bottom edge
		/**
		 * An array of elements from scrollItems that are currently within the viewport.
		 *
		 * @type {Array<Element>}
		 */
		var cur = scrollItems.map( function() {
			if ( $( this ).offset().top < viewportBottom ) {
				return this;
			}
		} );

		// Get the id of the last element in the filtered array (the one closest to the bottom)
		cur = cur[cur.length - 1];
		var id = ( cur && cur.length ) ? cur[0].id : '';

		menuItems
			.parent().removeClass( 'active' )
			.end().filter( '[href="#' + id + '"]' ).parent().addClass( 'active' );
	} );
} )( jQuery );
